import { render, staticRenderFns } from "./imgT.vue?vue&type=template&id=37532c1b"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37532c1b')) {
      api.createRecord('37532c1b', component.options)
    } else {
      api.reload('37532c1b', component.options)
    }
    module.hot.accept("./imgT.vue?vue&type=template&id=37532c1b", function () {
      api.rerender('37532c1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholdersNew/imgT.vue"
export default component.exports